var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 640,
    viewBox: "0 0 360 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_278)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_134_278)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.00144 84.8978C35.4107 84.552 81.6854 66.7147 92.9613 101.343C104.256 136.028 103.002 183.361 73.7489 205.148C43.1331 227.95 -0.561035 205.157 -31.7518 183.148C-63.964 160.419 -86.5215 139.958 -73.0092 102.919C-60.948 69.8578 -36.1885 85.232 -1.00144 84.8978Z",
    fill: "url(#paint0_linear_134_278)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_134_278)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.613 517.476C243.933 492.694 198.066 473.834 213.684 440.935C229.328 407.982 262.779 374.471 299.001 378.761C336.91 383.25 352.97 429.842 360.49 467.268C368.256 505.919 370.571 536.286 335.294 553.894C303.806 569.611 296.395 541.424 270.613 517.476Z",
    fill: "url(#paint1_linear_134_278)",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_134_278",
    x: -193.35,
    y: -36.3499,
    width: 409.262,
    height: 367.315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.175,
    result: "effect1_foregroundBlur_134_278"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_134_278",
    x: 94.1686,
    y: 262.038,
    width: 387.444,
    height: 412.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.175,
    result: "effect1_foregroundBlur_134_278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_278",
    x1: -80.002,
    y1: 218.148,
    x2: 112.908,
    y2: 133.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04C4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_134_278",
    x1: 419.591,
    y1: 475.023,
    x2: 221.484,
    y2: 403.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04C4D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 640,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios);
export default __webpack_public_path__ + "static/media/servicios.a6d6e6049da5c1cb2aa13be254d444d9.svg";
export { ForwardRef as ReactComponent };